import { forwardRef, type SVGProps } from 'react';

export interface ScalpelIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const ScalpelIcon = forwardRef<SVGSVGElement, ScalpelIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M6.89176 6.10071C7.02982 5.86159 7.33573 5.77958 7.57487 5.91761C7.814 6.05567 7.89602 6.36157 7.75797 6.60071L3.39371 14.1588L8.53043 12.7824L7.88102 10.3576C7.8467 10.2295 7.86453 10.093 7.93082 9.97816L9.35026 7.52015C9.4883 7.28104 9.79374 7.19907 10.0329 7.33704C10.272 7.47511 10.354 7.781 10.216 8.02015L8.90006 10.2985L9.62614 13.007C9.69749 13.2736 9.53924 13.5478 9.27262 13.6193L2.48698 15.4371C2.2917 15.4895 2.08422 15.4192 1.9611 15.2589C1.83799 15.0985 1.82336 14.8794 1.92448 14.7042L6.89176 6.10071Z"
      fill="currentColor"
    />
    <path
      d="M9.3635 1.81934C10.0894 0.56201 11.697 0.131096 12.9543 0.856941C14.2117 1.58287 14.6427 3.19087 13.9167 4.44825L11.4328 8.75001C11.2948 8.98893 10.9893 9.07095 10.7502 8.93311L7.06272 6.80421C6.94789 6.73792 6.86414 6.62856 6.82981 6.5005C6.79549 6.37244 6.81335 6.23592 6.87961 6.1211L9.3635 1.81934ZM12.4543 1.72315C11.6753 1.27338 10.679 1.54029 10.2292 2.31934L7.99582 6.188L10.8171 7.81641L13.0505 3.94825C13.5003 3.1692 13.2334 2.17295 12.4543 1.72315Z"
      fill="currentColor"
    />
  </svg>
));

ScalpelIcon.displayName = 'ScalpelIcon';
